export default {    
    Java: `public class Palindrome{
   static boolean isPalindrome(String str) {
      String reverseStr = "";
      int strLength = str.length();
      for (int i = (strLength - 1); i >=0; --i) {
          reverseStr = reverseStr + str.charAt(i);
      }
      if (str.toLowerCase().equals(reverseStr.toLowerCase())){
          return true;
      }else{
      return false;
      }
  }
  
  public static void main(String args[]) {
      int maxPal = -1;
      for (int i = 100; i < 1000; i++) {
          for (int j = 100; j < 1000; j++) {
              int prod = i * j;
              if (isPalindrome(Integer.toString(prod)) && prod > maxPal)
                  maxPal = prod;
          }
      }
      System.out.println(maxPal);
  }
}`,
    JavaScript: `    function isPalind(sVal){
        return sVal == sVal.split('').reverse().join('')
    }
    
    const runProcess = () => {
        let maximumPal = 0
        for (let i=100; i<=999; i++){
            for (let j=100; j<=999; j++){
                let prod = i*j
                let strProd = prod.toString()
                if ((isPalind(strProd)) && (prod > maximumPal)){
                    maximumPal = prod
                }
           }
        }
        console.log(maximumPal)
}`,
    Python: `def runProcess():
	largestPalindrome = max(i * j
		for i in range(100, 1000)
		for j in range(100, 1000)
		if str(i * j) == str(i * j)[ : : -1])
return str(largestPalindrome)
    `
}

